// common functions used when building UI types

// import { maybe, getWith } from "./functions"

export const normalizeOptions = options => {
    let d = {
        ...options
    }

    for (let [key, value] of Object.entries (d)) {
      // console.log(`key: ${key} value: ${value}`)
        switch (value) {
            case "True":
            case "true":
                d[key] = true
                break
            case "False":
            case "false":
                d[key] = false
                break
        }
    }

    return d
}

// old versions of safari doesn't treat dataset as an object?
// Is this still necessary?
const datasetToObject = function(elem) {
    const data = {}
    ;[].forEach.call (elem.attributes, attr => {
        if (/^data-/.test (attr.name)) {
            const camelCaseName = attr.name
                .substr (5)
                .replace (/-(.)/g, ($0, $1) => $1.toUpperCase ())
            data[camelCaseName] = attr.value
        }
    })
    return data
}

export function parseOptions() {
  // this.log.warn(`here`)
    if (!this.dom) {
        console.log ("no dom? not parsing options");
        return
    }

    let options = {}
    if (this.defaultOptions) {
        options = {
            ...this.defaultOptions,
            ...options
        }
    }

    if (this.options) {
        options = {
            ...this.options
        }
    }
    // console.log(`options 1:`, {... this.options}, this.options == null)
    // console.log(`dom:`, {... this.dom}, this.dom.options == null)
    if (this.dom.dataset && this.dom.dataset.options) {
        let d = JSON.parse (this.dom.dataset.options)
        d = normalizeOptions (d)
        options = { ...options, ...d }
    }
    if (this.dom.dataset) {
        let d = normalizeOptions (datasetToObject (this.dom))
        // this.log.warn(`normalized options: 1:`, {... d})
        options = { ...options, ...d }
        // this.log.warn(`normalized options: 2:`, {... options})
    }
    this.options = options
    // console.log(`options:`, {... options}, options == null)

    return options
}

// export function parseOptions2() {
//     let options = {}
//     if (this.defaultOptions) {
//         options = {
//             ...this.defaultOptions,
//             ...options
//         }
//     }

//     if (this.options) {
//         options = {
//             ...this.options
//         }
//     }

//     const setOptions = (options, json) => {
//         console.log(`setOptions: json:`, json)
//         let d = JSON.parse(json)
//         d = normalizeOptions(d)
//         return { ...options, ...d }
//     }

//     options = maybe((options, dom) => {
//         console.log(`options 1:`, { ...options }, options == null)
//         console.log(`dom:`, { ...dom }, dom.options == null)

//         let test = maybe(setOptions)(options, getWith("options")(dom.dataset))

//         options = test == null ? options : test
//         console.log(`options 2:`, { ...options }, options == null)

//         return maybe(setOptions)(
//             options,
//             datasetToObject(dom),
//             getWith("dataset")(dom)
//         )
//     })(options, this.dom)
//     options = options == null ? {} : options
//     console.log(`options 3:`, { ...options }, options == null)
//     this.options = options

//     return options
// }

// export const parseOptions = parseOptions1
// export const parseOptions = parseOptions2;

import { initLog as initLog1 } from "./logging"
export const initLog = initLog1

// // for backwards compatability: makeType had to move to types.js, because of circular dependencies;
import { makeType as makeType1 } from "./types"
export const makeType = makeType1
